import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import RequestAccessInfoImage from "../../assets/images/RequestAccessInfoModal.png";

const DatasetDetailsInfoModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">
        {"Request New Access Info"}
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          {/* <Typography variant="h6" align="center">
            Maestro - Unified In-House Data and Analytics Platform
          </Typography> */}
          <p style={{ fontSize: "1rem" }}>
            <span>Maestro</span> - Unified In-House Data and Analytics Platform
          </p>
          <p style={{ fontSize: "1rem" }}>
            <span>Path Link</span> -{" "}
            <a
              href="https://maersk.ssmcloud.net/ECMv6/request/requestHome"
              target="_blank"
            >
              https://maersk.ssmcloud.net/ECMv6/request/requestHome
            </a>
          </p>
          <Box mt={2}>
            <img
              src={RequestAccessInfoImage}
              alt="Request Access Info Image"
              width={"860px"}
              style={{ border: "1px solid #d3d3d3", borderRadius: "6px" }}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DatasetDetailsInfoModal;
